'use client';

import React, { type FC } from 'react';
import { useTranslations } from 'next-intl';
import { NavMenu, NavMenuItem } from '@spellix/ui';
import { Link, usePathname } from '@repo/i18n';
import { matchPathPattern } from '@repo/routing';
import { HEADER_MENU_ITEMS } from '@/modules/layout/constants';

export const HeaderNavigation: FC = () => {
  const pathname = usePathname();
  const t = useTranslations('web.header');

  return (
    <div className="hidden w-full md:flex md:items-center md:justify-center">
      <NavMenu variant="ghost" className="mx-auto">
        {Object.entries(HEADER_MENU_ITEMS).map(([key, value]) => {
          const isActive = matchPathPattern(pathname, value.base, { strict: true });

          return (
            <NavMenuItem asChild key={key} isActive={Boolean(isActive)}>
              <Link href={value.path()}>{t(value.label)}</Link>
            </NavMenuItem>
          );
        })}
      </NavMenu>
    </div>
  );
};
